export default "__VITE_ASSET__BwvrW1I___";